import utility from './utility';
import dataHelper from './dataHelper';
import constants from './constants';

export default {
  name: 'youthHelper',
  mixins: [utility, dataHelper],
  methods: {
    replaceName(textContent) {
      let result = this.replaceText(textContent, constants.SECONDARYFIRSTNAME, this.su_firstName);
      const puFullName = this.pu_middleName ? `${this.pu_firstName} ${this.pu_middleName} ${this.pu_lastName}` : `${this.pu_firstName} ${this.pu_lastName}`;
      result = this.replaceText(result, constants.PRIMARYFULLNAME, puFullName.toUpperCase());
      const suFullName = this.su_middleName ? `${this.su_firstName} ${this.su_middleName} ${this.su_lastName}` : `${this.su_firstName} ${this.su_lastName}`;
      return this.replaceText(result, constants.SECONDARYFULLNAME, suFullName.toUpperCase());
    },
  },
};
